import { render, staticRenderFns } from "./EventListItems.vue?vue&type=template&id=705f4744&scoped=true&"
import script from "./EventListItems.vue?vue&type=script&lang=js&"
export * from "./EventListItems.vue?vue&type=script&lang=js&"
import style0 from "./EventListItems.vue?vue&type=style&index=0&id=705f4744&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705f4744",
  null
  
)

export default component.exports